import React from 'react';
import { Box, Card, CardContent, Typography, Avatar } from '@material-ui/core';
import LinearProgress from '@mui/material/LinearProgress';
import UploadIcon from '@mui/icons-material/Upload';
import useStyles from './ScoreBoardCardStyles';  // External styles

const teamsData = [
  {
    initials: 'SA',
    name: 'Solutions & Apps',
    productionReadiness: 70,
    monitoringMaturity: 50,
    doraMetrics: 10
  },
  {
    initials: 'SH',
    name: 'SolutionHub',
    productionReadiness: 50,
    monitoringMaturity: 80,
    doraMetrics: 50
  },
  {
    initials: 'ESM',
    name: 'ESM',
    productionReadiness: 50,
    monitoringMaturity: 60,
    doraMetrics: 40
  },
  {
    initials: 'UNI',
    name: 'Unicaja',
    productionReadiness: 95,
    monitoringMaturity: 70,
    doraMetrics: 80
  }
];

const getScoreColor = (score: number) => {
  if (score < 50) return '#ff6b6b'; // Soft red for low scores
  if (score < 75) return '#feca57'; // Yellow-orange for medium scores
  return '#1dd1a1'; // Aqua/teal for high scores
};

const calculateScore = (team: any) => {
  // Calculate the mean of the three parameters and round up
  const meanScore = (team.productionReadiness + team.monitoringMaturity + team.doraMetrics) / 3;
  return Math.ceil(meanScore);
};

const ScoreBoardCard = () => {
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <UploadIcon className={classes.rankIcon} />
          <Typography variant="h5" gutterBottom>Team Ranking</Typography>
        </Box>

        <table className={classes.table}>
          <thead>
            <tr>
              <th className={classes.th}>TEAM</th>
              <th className={classes.th}>PRODUCTION READINESS</th>
              <th className={classes.th}>MONITORING MATURITY</th>
              <th className={classes.th}>DORA METRICS</th>
              <th className={classes.th}>SCORE</th>
            </tr>
          </thead>
          <tbody>
            {teamsData.map((team, index) => {
              const score = calculateScore(team);
              const scoreColor = getScoreColor(score);
              
              return (
                <tr key={index}>
                  <td className={classes.td}>
                    <Box className={classes.titleBox}>
                      <Avatar className={classes.avatar} src='vf-icon.png' />
                      <Typography variant="body1">{team.name}</Typography>
                    </Box>
                  </td>
                  <td className={classes.td}>
                    <LinearProgress
                      variant="determinate"
                      value={team.productionReadiness}
                      className={classes.progressBar}
                      classes={{ bar: classes.productionReadinessColor }}
                    />
                  </td>
                  <td className={classes.td}>
                    <LinearProgress
                      variant="determinate"
                      value={team.monitoringMaturity}
                      className={classes.progressBar}
                      classes={{ bar: classes.monitoringMaturityColor }}
                    />
                  </td>
                  <td className={classes.td}>
                    <LinearProgress
                      variant="determinate"
                      value={team.doraMetrics}
                      className={classes.progressBar}
                      classes={{ bar: classes.doraMetricsColor }}
                    />
                  </td>
                  <td className={classes.td}>
                    {/* Score Badge */}
                    <span
                      className={classes.scoreBadge}
                      style={{
                        backgroundColor: scoreColor,  // Set badge color dynamically
                        color: '#fff'
                      }}
                    >
                      {`${score}`}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
};


export default ScoreBoardCard;
